import React from "react";
import { IGKLayoutShellProps } from "@granular/gds-ux-components";

import FabricProvider from "./FabricProvider";
import Login from "./Login";
import FabricFeatureFlags from "./FabricFeatureFlags";
import { getHistory } from "../services/history";
import { Router } from "react-router-dom";
import { ChildrenProp } from "../types";

import { InjectedTranslations } from "../models/locale";

export type NavProps = Omit<IGKLayoutShellProps, "alertsOverlay">;

export type ShellProps = {
  /**
   * You may pass an object of translations into this property if you need to override the translations that the operation creation component uses (it's what provides the operation creation UX, for example).
   *
   * 🚨 This property will only affect the operation creation flow while it is contained in the core. CDC is working on a [standalone operation creation epic](https://granular.atlassian.net/browse/CAT-2122) that will replace this flow and therefore remove this customization. 🚨
   */
  UNSAFE_injectedTranslations?: InjectedTranslations;

  /**
   * Set/override navigation props.
   * These props are normally provided by the container.
   */
  navProps?: NavProps | (() => NavProps);
  translateRoutes?: boolean;
} & ChildrenProp;

const FabricShell: React.FC<ShellProps> = (props) => {
  return (
    <FabricProvider>
      <Router history={getHistory()}>
        <FabricFeatureFlags>
          <Login {...props} />
        </FabricFeatureFlags>
      </Router>
    </FabricProvider>
  );
};

export default FabricShell;
